/* global axios */
import ApiClient from './ApiClient';

class MetaCampaignsAdSetsAPI extends ApiClient {
  constructor() {
    super('meta_campaigns/campaigns', { accountScoped: true });
  }

  get(campaignId, params = {}) {
    return axios.get(`${this.url}/${campaignId}/ad_sets`, { params });
  }
}

export default new MetaCampaignsAdSetsAPI();
